import * as React from "react";
import { createIcon } from "@chakra-ui/react";

const Tag = createIcon({
  path: (
    <path
      d="M10.6333 19.0087C9.31399 20.3275 7.94196 20.3363 6.60511 18.9999L0.993854 13.4081C-0.342997 12.0804 -0.316612 10.6825 0.985059 9.38125L9.62182 0.764919C10.3078 0.0791296 10.7036 0 11.6975 0H15.0396C16.007 0 16.3325 0.237389 17.0449 0.940763L19.0589 2.95417C19.7713 3.66634 20 3.99165 20 4.95879V8.29981C20 9.29333 19.9296 9.69777 19.2436 10.3836L10.6333 19.0087ZM13.4916 7.31509C14.2128 7.31509 14.7581 6.75239 14.7581 6.04902C14.7581 5.34564 14.2128 4.79174 13.4916 4.79174C12.7792 4.79174 12.234 5.34564 12.234 6.04902C12.234 6.75239 12.7792 7.31509 13.4916 7.31509Z"
      fill="currentColor"
    />
  ),
  viewBox: "0 0 20 20",
});

export { Tag };
